/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import CustomerService from '../../service/customer';
import WyPanelUtils from '../../components/panel-views/utils/wy-panel-util.js';
import WyFilter from '../../library/wy-filter.js';
import _ from 'lodash';
const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  async fetchIntentToCustomerFeedbackChartData({getters}, selection) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.selection = selection
    let res = await CustomerService.fetchIntentToCustomerFeedbackChartData(getters.authUser, payload);
    let viewByData = null
    if(res && res.data) {
      viewByData = res.data;
    }
    return viewByData;
  },

  // eslint-disable-next-line no-unused-vars
  async prepareCustomerBehaviourViewByData({getters, commit},{viewBy, rawData, templateData, companyConfig}) {
    if(rawData) {
      let viewByData = JSON.parse(JSON.stringify(rawData))
      let viewByDailyData = JSON.parse(JSON.stringify(rawData));
      let panelName = Object.keys(viewByData)[0]
      if(viewBy && panelName) {
        let legendOriginColors = [];
        if(companyConfig && companyConfig.legends && companyConfig.legends.legendColors && companyConfig.legends.legendColors.length > 0) {
          legendOriginColors = _.uniq(_.concat(companyConfig.legends.legendColors, getters.legendDefaultColors));
          // legendOriginColors = companyConfig.legends.legendColors;
        }
        else {
          legendOriginColors = getters.legendDefaultColors
        }
        // console.log(getters.companyConfig, getters.legendOriginColors)
        commit('updateLegendOriginColors', {colors: legendOriginColors});
        commit('updateLegendColors', {colors: legendOriginColors});
        switch (panelName) {
          case 'customerFeedback': {
            viewByData[panelName].containedFeedbackPieChartLegendKeys = ['positiveFeedback', 'negativeFeedback', 'noFeedback', 'mixedFeedback'];
            viewByData[panelName].handedOffFeedbackPieChartLegendKeys = ['positiveFeedback', 'negativeFeedback', 'noFeedback', 'mixedFeedback'];
            viewByData.customerFeedback.feedbackRateLineChartData = WyPanelUtils.arverageGroupBy(viewBy, viewByData.customerFeedback.feedbackRateLineChartData, ['feedbackRate'])
            viewByData.customerFeedback.containedFeedbackBarChartData = WyPanelUtils.totalVolumGroupBy(viewBy, viewByData.customerFeedback.containedFeedbackBarChartData, viewByData[panelName].containedFeedbackPieChartLegendKeys)
            viewByData.customerFeedback.handedOffFeedbackBarChartData = WyPanelUtils.totalVolumGroupBy(viewBy, viewByData.customerFeedback.handedOffFeedbackBarChartData, viewByData[panelName].handedOffFeedbackPieChartLegendKeys)
            return WyPanelUtils.formatPanelChartData(viewByData, viewByDailyData, panelName, templateData, viewBy, legendOriginColors);
          }
          case 'responseFeedback': {
            return rawData;
          }
          case 'liveAgentHandling': {
            let averageHandlingTimeBarChartData = [];
            let averageBotTimeBarChartData = [];
            let averageResponseTimeBarChartData = [];
            let averageWaitTimeBarChartData = [];
            
            let averageHandlingTimeLineChartData = [];
            let averageBotTimeLineChartData = [];
            let averageResponseTimeLineChartData = [];
            let averageWaitTimeLineChartData = [];

            let averageHandlingTimePieData = {};
            let averageBotTimePieData = {};
            let averageResponseTimePieData = {};
            let averageWaitTimePieData = {};

            viewByData[panelName].dailyData.forEach((data)=>{

              //handlingTime
              // let liveAgentHandlingChartData = [];
              let averageHandlingTimeData = {};
              averageHandlingTimeData.key = "averageHandlingTime";
              averageHandlingTimeData.date = data.date;
              // averageHandlingTimeBarChartData.push(averageHandlingTimeData)

              let averageBotTimeData = {};
              averageBotTimeData.key = "averageBotTime";
              averageBotTimeData.date = data.date;
              // averageBotTimeBarChartData.push(averageBotTimeData);

              let averageResponseTimeData = {};
              averageResponseTimeData.key = "averageResponseTime";
              averageResponseTimeData.date = data.date;
              // averageResponseTimeBarChartData.push(averageResponseTimeData);

              let averageWaitTimeData = {};
              averageWaitTimeData.key = "averageWaitTime";
              averageWaitTimeData.date = data.date;
              // averageWaitTimeBarChartData.push(averageWaitTimeData);

              averageHandlingTimeBarChartData.push(WyPanelUtils.generateHandlingTimesGroupByData(viewBy, templateData, data.conversations, averageHandlingTimeData, averageHandlingTimePieData));
              averageBotTimeBarChartData.push(WyPanelUtils.generateHandlingTimesGroupByData(viewBy, templateData, data.conversations, averageBotTimeData, averageBotTimePieData));
              averageResponseTimeBarChartData.push(WyPanelUtils.generateHandlingTimesGroupByData(viewBy, templateData, data.conversations, averageResponseTimeData, averageResponseTimePieData));
              averageWaitTimeBarChartData.push(WyPanelUtils.generateHandlingTimesGroupByData(viewBy, templateData, data.conversations, averageWaitTimeData, averageWaitTimePieData));
              
              let averageHandlingTimeLine = {};
              averageHandlingTimeLine.date = data.date;
              averageHandlingTimeLine.averageHandlingTime = data.averageHandlingTime;
              averageHandlingTimeLineChartData.push(averageHandlingTimeLine)

              let averageBotTimeLine = {};
              averageBotTimeLine.date = data.date;
              averageBotTimeLine.averageBotTime = data.averageBotTime;
              averageBotTimeLineChartData.push(averageBotTimeLine)

              let averageResponseTimeLine = {};
              averageResponseTimeLine.date = data.date;
              averageResponseTimeLine.averageResponseTime = data.averageResponseTime;
              averageResponseTimeLineChartData.push(averageResponseTimeLine)

              let averageWaitTimeLine = {};
              averageWaitTimeLine.date = data.date;
              averageWaitTimeLine.averageWaitTime = data.averageWaitTime;
              averageWaitTimeLineChartData.push(averageWaitTimeLine)
            })
            // console.log(averageHandlingTimeLineChartData)
            //prepare Pie Chart Data
            viewByData[panelName].averageHandlingTimePieChartData = WyPanelUtils.preparePieData(averageHandlingTimePieData);
            viewByData[panelName].averageBotTimePieChartData = WyPanelUtils.preparePieData(averageBotTimePieData);
            viewByData[panelName].averageResponseTimePieChartData = WyPanelUtils.preparePieData(averageResponseTimePieData);
            viewByData[panelName].averageWaitTimePieChartData = WyPanelUtils.preparePieData(averageWaitTimePieData);

            viewByData[panelName].averageHandlingTimeBarChartData = WyPanelUtils.totalVolumGroupBy(viewBy, averageHandlingTimeBarChartData, averageHandlingTimeBarChartData[0].legends)
            viewByData[panelName].averageBotTimeBarChartData = WyPanelUtils.totalVolumGroupBy(viewBy, averageBotTimeBarChartData, averageBotTimeBarChartData[0].legends)
            viewByData[panelName].averageResponseTimeBarChartData = WyPanelUtils.totalVolumGroupBy(viewBy, averageResponseTimeBarChartData, averageResponseTimeBarChartData[0].legends)
            viewByData[panelName].averageWaitTimeBarChartData = WyPanelUtils.totalVolumGroupBy(viewBy, averageWaitTimeBarChartData, averageWaitTimeBarChartData[0].legends)

            viewByData[panelName].averageHandlingTimePieChartLegendKeys = averageHandlingTimeBarChartData[0].legends;
            viewByData[panelName].averageBotTimePieChartLegendKeys = averageBotTimeBarChartData[0].legends;
            viewByData[panelName].averageResponseTimePieChartLegendKeys = averageResponseTimeBarChartData[0].legends;
            viewByData[panelName].averageWaitTimePieChartLegendKeys = averageWaitTimeBarChartData[0].legends;

            viewByData[panelName].averageHandlingTimeLineChartData = WyPanelUtils.arverageTimeGroupBy(viewBy, averageHandlingTimeLineChartData, ['averageHandlingTime']);
            viewByData[panelName].averageBotTimeLineChartData = WyPanelUtils.arverageTimeGroupBy(viewBy, averageBotTimeLineChartData, ['averageBotTime']);
            viewByData[panelName].averageResponseTimeLineChartData = WyPanelUtils.arverageTimeGroupBy(viewBy, averageResponseTimeLineChartData, ['averageResponseTime']);
            viewByData[panelName].averageWaitTimeLineChartData = WyPanelUtils.arverageTimeGroupBy(viewBy, averageWaitTimeLineChartData, ['averageWaitTime'])

            viewByDailyData[panelName].averageHandlingTimeLineChartData = WyPanelUtils.changeTimeFormat(averageHandlingTimeLineChartData, 'averageHandlingTime'); //WyPanelUtils.arverageTimeGroupBy(viewBy, averageHandlingTimeLineChartData, ['averageHandlingTime']);
            viewByDailyData[panelName].averageBotTimeLineChartData = WyPanelUtils.changeTimeFormat(averageBotTimeLineChartData, 'averageBotTime'); //WyPanelUtils.arverageTimeGroupBy(viewBy, averageBotTimeLineChartData, ['averageBotTime']);
            viewByDailyData[panelName].averageResponseTimeLineChartData = WyPanelUtils.changeTimeFormat(averageResponseTimeLineChartData, 'averageResponseTime'); //WyPanelUtils.arverageTimeGroupBy(viewBy, averageResponseTimeLineChartData, ['averageResponseTime']);
            viewByDailyData[panelName].averageWaitTimeLineChartData = WyPanelUtils.changeTimeFormat(averageWaitTimeLineChartData, 'averageWaitTime');
            // let traceData = dynamicCreateTraceData(averageHandlingTimeBarChartData[0].legends);
            templateData.data.forEach(tabData => {
              if(tabData.key == averageHandlingTimeBarChartData[0].key) {
                tabData.columnChartData.legends = averageHandlingTimeBarChartData[0].legends;
                tabData.pieChartData.legends = averageHandlingTimeBarChartData[0].legends;
                tabData.pieChartData.title = 'Agent handling time by conversation volume - ';
                tabData.columnChartData.traceData = WyPanelUtils.dynamicCreateTraceData(averageHandlingTimeBarChartData[0].legends);
              }

              if(tabData.key == averageBotTimeBarChartData[0].key) {
                tabData.columnChartData.legends = averageBotTimeBarChartData[0].legends;
                tabData.pieChartData.legends = averageBotTimeBarChartData[0].legends;
                tabData.pieChartData.title = 'VA handling time by conversation volume - ';
                tabData.columnChartData.traceData = WyPanelUtils.dynamicCreateTraceData(averageBotTimeBarChartData[0].legends);
              }

              if(tabData.key == averageResponseTimeBarChartData[0].key) {
                tabData.columnChartData.legends = averageResponseTimeBarChartData[0].legends;
                tabData.pieChartData.legends = averageResponseTimeBarChartData[0].legends;
                tabData.pieChartData.title = 'Agent response time by conversation volume - ';
                tabData.columnChartData.traceData = WyPanelUtils.dynamicCreateTraceData(averageResponseTimeBarChartData[0].legends);
              }
              if(tabData.key == averageWaitTimeBarChartData[0].key) {
                tabData.columnChartData.legends = averageWaitTimeBarChartData[0].legends;
                tabData.pieChartData.legends = averageWaitTimeBarChartData[0].legends;
                tabData.pieChartData.title = 'Agent wait time by conversation volume - ';
                tabData.columnChartData.traceData = WyPanelUtils.dynamicCreateTraceData(averageWaitTimeBarChartData[0].legends);
              }
            })
            return WyPanelUtils.formatPanelChartData(viewByData, viewByDailyData, panelName, templateData, viewBy, legendOriginColors);
            // return templateData
          }
          case 'conversationsByChannels': {
            let channelList = [];
            const channelTotalList = [];
            viewByData[panelName].fieldList.forEach(field => {
              channelList.push(field.prefix);
              channelTotalList.push('total' + field.suffix);
              WyPanelUtils.updateLegendMap(field);
            })

            let channelOriginList = [];
            let channelFullList = getters.channelOriginList;
            if(companyConfig && companyConfig.channels && companyConfig.channels.length > 0) {
              channelOriginList = WyPanelUtils.mergeList(companyConfig.channels, channelFullList);
            }
            else {
              channelOriginList = channelFullList;
            }
            channelList = WyPanelUtils.updateFieldList(channelOriginList, channelList)
            let legendColors = WyPanelUtils.getLegendColor(channelOriginList, legendOriginColors, channelList)
            commit('updateLegendColors', {colors: WyPanelUtils.getLegendColor(channelOriginList, legendOriginColors, channelList)});
            viewByData[panelName].fieldList = WyPanelUtils.updateFieldObjectList(viewByData[panelName].fieldList, channelList);
            // console.log(legendOriginColors, channelOriginList, getters.legendColors, channelList, viewByData[panelName].fieldList, channelFullList)
            templateData = WyPanelUtils.dynamicCreateTemplateData(templateData, channelList, viewByData[panelName].fieldList);
            viewByData[panelName].conversationsPieChartLegendKeys = channelList;

            viewByData[panelName].conversationsBarChartData = WyPanelUtils.totalVolumGroupBy(viewBy, viewByData[panelName].conversationsBarChartData, viewByData[panelName].conversationsPieChartLegendKeys)
            channelList.forEach(channel => {
              viewByData[panelName][channel + 'PieChartLegendKeys'] = ['positiveFeedback', 'negativeFeedback', 'noFeedback', 'mixedFeedback'];
              viewByData[panelName][channel + 'BarChartData'] = WyPanelUtils.totalVolumGroupBy(viewBy, viewByData[panelName][channel + 'BarChartData'], viewByData[panelName][channel + 'PieChartLegendKeys'])
            })
            return WyPanelUtils.formatPanelChartData(viewByData, viewByDailyData, panelName, templateData, viewBy, legendOriginColors, legendColors);
          }

          case 'conversationsByDevices': {
            let deviceList = [];
            const deviceTotalList = [];
            const deviceMap = {
              '-': 'Unknown'
            }
            viewByData[panelName].fieldList.forEach(field => {
              if(deviceMap[field.label]){
                field.label = deviceMap[field.label]
              }
              deviceList.push(field.prefix);
              deviceTotalList.push('total'+field.suffix);
              WyPanelUtils.updateLegendMap(field);
            })
            
            let deviceOriginList = [];
            let deviceFullList = getters.deviceOriginList;
            if(companyConfig && companyConfig.devices && companyConfig.devices.length > 0) {
              deviceOriginList = WyPanelUtils.mergeList(companyConfig.devices, deviceFullList);
            }
            else {
              deviceOriginList = deviceFullList;
            }
            deviceList = WyPanelUtils.updateFieldList(deviceOriginList, deviceList)
            let legendColors = WyPanelUtils.getLegendColor(deviceOriginList, legendOriginColors, deviceList)
            commit('updateLegendColors', {colors: WyPanelUtils.getLegendColor(deviceOriginList, legendOriginColors, deviceList)});
            viewByData[panelName].fieldList = WyPanelUtils.updateFieldObjectList(viewByData[panelName].fieldList, deviceList);
            // console.log(legendOriginColors, deviceOriginList, getters.legendColors, deviceList, deviceFullList)
            templateData = WyPanelUtils.dynamicCreateTemplateData(templateData, deviceList, viewByData[panelName].fieldList);

            viewByData[panelName].conversationsPieChartLegendKeys = deviceList;
            viewByData[panelName].conversationsBarChartData = WyPanelUtils.totalVolumGroupBy(viewBy, viewByData[panelName].conversationsBarChartData, viewByData[panelName].conversationsPieChartLegendKeys)
            deviceList.forEach(device => {
              viewByData[panelName][device + 'PieChartLegendKeys'] = ['positiveFeedback', 'negativeFeedback', 'noFeedback', 'mixedFeedback'];
              viewByData[panelName][device + 'BarChartData'] = WyPanelUtils.totalVolumGroupBy(viewBy, viewByData[panelName][device + 'BarChartData'], viewByData[panelName][device + 'PieChartLegendKeys'])
            })
            return WyPanelUtils.formatPanelChartData(viewByData, viewByDailyData, panelName, templateData, viewBy, legendOriginColors, legendColors);
          }

          case 'newAndReturingCustomerConversations': {
            viewByData[panelName].conversationsPieChartLegendKeys = ['newCustomers', 'returningCustomers'];
            viewByData[panelName].newCustomerConversationsPieChartLegendKeys = ['positiveFeedback', 'negativeFeedback', 'noFeedback', 'mixedFeedback'];
            viewByData[panelName].returningCustomerConversationsPieChartLegendKeys = ['positiveFeedback', 'negativeFeedback', 'noFeedback', 'mixedFeedback'];

            viewByData[panelName].conversationsBarChartData = WyPanelUtils.totalVolumGroupBy(viewBy, viewByData[panelName].conversationsBarChartData, viewByData[panelName].conversationsPieChartLegendKeys)
            viewByData[panelName].newCustomerConversationsBarChartData = WyPanelUtils.totalVolumGroupBy(viewBy, viewByData[panelName].newCustomerConversationsBarChartData, viewByData[panelName].newCustomerConversationsPieChartLegendKeys)
            viewByData[panelName].returningCustomerConversationsBarChartData = WyPanelUtils.totalVolumGroupBy(viewBy, viewByData[panelName].returningCustomerConversationsBarChartData, viewByData[panelName].returningCustomerConversationsPieChartLegendKeys)
            return WyPanelUtils.formatPanelChartData(viewByData, viewByDailyData, panelName, templateData, viewBy, legendOriginColors);
          }

          case 'usagePerCustomer': {
            let averageConversationsBarChartData = [];
            let lifetimeConversationsBarChartData = [];

            let averageConversationsLineChartData = [];
            let lifetimeConversationsLineChartData = [];

            let averageConversationsPieData = {};
            let lifetimeConversationsPieData = {};

            viewByData[panelName].averageConversationsDailyData.forEach((data)=>{
              let averageConversationsData = {};
              averageConversationsData.key = "averageConversations";
              averageConversationsData.date = data.date;
              averageConversationsBarChartData.push(WyPanelUtils.generateUsagePerCustomerGroupByData(viewBy, templateData, data.info, averageConversationsData, averageConversationsPieData));
              
              let averageConversationsLine = {};
              averageConversationsLine.date = data.date;
              averageConversationsLine.averageConversations = data.averageConversations;
              averageConversationsLineChartData.push(averageConversationsLine)

            })
            viewByData[panelName].lifetimeConversationsDailyData.forEach((data)=>{
              let lifetimeConversationsData = {};
              lifetimeConversationsData.key = "lifetimeConversations";
              lifetimeConversationsData.date = data.date;
              lifetimeConversationsBarChartData.push(WyPanelUtils.generateUsagePerCustomerGroupByData(viewBy, templateData, data.info, lifetimeConversationsData, lifetimeConversationsPieData));
              
              let lifetimeConversationsLine = {};
              lifetimeConversationsLine.date = data.date;
              lifetimeConversationsLine.lifetimeConversations = data.lifetimeConversations;
              lifetimeConversationsLineChartData.push(lifetimeConversationsLine)
            })
            
            //prepare Pie Chart Data
            viewByData[panelName].averageConversationsPieChartData = WyPanelUtils.preparePieData(averageConversationsPieData);
            viewByData[panelName].lifetimeConversationsPieChartData = WyPanelUtils.preparePieData(lifetimeConversationsPieData);

            viewByData[panelName].averageConversationsBarChartData = WyPanelUtils.totalVolumGroupBy(viewBy, averageConversationsBarChartData, averageConversationsBarChartData[0].legends)
            viewByData[panelName].lifetimeConversationsBarChartData = WyPanelUtils.totalVolumGroupBy(viewBy, lifetimeConversationsBarChartData, lifetimeConversationsBarChartData[0].legends)
            // console.log(viewByData[panelName])

            viewByData[panelName].averageConversationsPieChartLegendKeys = averageConversationsBarChartData[0].legends;
            viewByData[panelName].lifetimeConversationsPieChartLegendKeys = lifetimeConversationsBarChartData[0].legends;

            viewByData[panelName].averageConversationsLineChartData = WyPanelUtils.arverageGroupBy(viewBy, averageConversationsLineChartData, ['averageConversations']);
            viewByData[panelName].lifetimeConversationsLineChartData = WyPanelUtils.arverageGroupBy(viewBy, lifetimeConversationsLineChartData, ['lifetimeConversations']);

            viewByDailyData[panelName].averageConversationsLineChartData = averageConversationsLineChartData; 
            viewByDailyData[panelName].lifetimeConversationsLineChartData = lifetimeConversationsLineChartData;

            // let traceData = dynamicCreateTraceData(averageHandlingTimeBarChartData[0].legends);
            templateData.data.forEach(tabData => {
              if(tabData.key == averageConversationsBarChartData[0].key) {
                tabData.columnChartData.legends = averageConversationsBarChartData[0].legends;
                tabData.pieChartData.legends = averageConversationsBarChartData[0].legends;
                tabData.pieChartData.title = 'Average conversations by user volume - ';// + averageConversationsBarChartData[0].legends.join(', ');
                tabData.columnChartData.traceData = WyPanelUtils.dynamicCreateTraceData(averageConversationsBarChartData[0].legends);
              }
              if(tabData.key == lifetimeConversationsBarChartData[0].key) {
                tabData.columnChartData.legends = lifetimeConversationsBarChartData[0].legends;
                tabData.pieChartData.legends = lifetimeConversationsBarChartData[0].legends;
                tabData.pieChartData.title = 'Lifetime conversations by user volume - ';// + legends.join(', ');
                tabData.columnChartData.traceData = WyPanelUtils.dynamicCreateTraceData(lifetimeConversationsBarChartData[0].legends);
              }
            })
            // console.log(panelName, templateData)
            return WyPanelUtils.formatPanelChartData(viewByData, viewByDailyData, panelName, templateData, viewBy, legendOriginColors);
          }

          default:
            // return templateData;
            // return formatPanelChartData(viewByData, panelName, templateData, viewBy);
        }
      }
      else {
        return {}
      }
    }
    else {
      return templateData;
    }
  },

  
  async fetchIntentToLiveAgentHandlingChartData({getters}, selection) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.selection = selection
    let res = await CustomerService.fetchIntentToLiveAgentHandlingChartData(getters.authUser, payload);
    let viewByData = null
    if(res && res.data && res.status == 200) {
      viewByData = res.data;
    }
    return viewByData;
  },
  
  async fetchIntentToCustomerByDevicesChartData({getters}, selection) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.selection = selection
    let res = await CustomerService.fetchIntentToCustomerByDevicesChartData(getters.authUser, payload);
    let viewByData = null
    if(res && res.data && res.status == 200) {
      viewByData = res.data;
    }
    return viewByData;
  },

  async fetchIntentToCustomerByChannelsChartData({getters}, selection) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload.selection = selection
    let res = await CustomerService.fetchIntentToCustomerByChannelsChartData(getters.authUser, payload);
    let viewByData = null
    if(res && res.data && res.status == 200) {
      viewByData = res.data;

      // do label mapping
      if(viewByData.conversationsByChannels.fieldList && Array.isArray(viewByData.conversationsByChannels.fieldList)) {
        const custTypesMap = getters.authUser.config.app.configs.channelsMapping || {};
        viewByData.conversationsByChannels.fieldList.map(item => {
          if(custTypesMap[item.key] && custTypesMap[item.key] != '') {
            item.label = custTypesMap[item.key];
          }
        })
      }
    }
    return viewByData;
  },

  async fetchNewAndReturningUsers({getters}) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    let res = await CustomerService.fetchNewAndReturningUsers(getters.authUser, payload);
    let viewByData = null
    if(res && res.data && res.status == 200) {
      viewByData = res.data;
    }
    return viewByData;
  },

  async fetchUsagePerCustomer({getters}) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    let res = await CustomerService.fetchUsagePerCustomer(getters.authUser, payload);
    let viewByData = null
    if(res && res.data && res.status == 200) {
      viewByData = res.data;
    }
    return viewByData;
  },

  async fetchCustomerLocationData({getters}) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    let res = await CustomerService.fetchCustomerLocationData(getters.authUser, payload);
    let viewByData = null
    if(res && res.data && res.status == 200) {
      viewByData = res.data;
    }
    return viewByData;
  },

  async fetchJourneyAndResponseFeedback({getters}, options) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    if(options) {
      payload.sortOrder = options.sortOrder;
      payload.sortBy = options.sortBy;
      payload.feedbackType = options.feedbackType;
      payload.pageNumber = options.pageNo;
      payload.pageSize = options.pageSize;
    }
    let res = await CustomerService.fetchJourneyAndResponseFeedback(getters.authUser, payload);
    let viewByData = null
    if(res && res.data && res.status == 200) {
      viewByData = res.data;
    }
    return viewByData;
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}